import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Button, Chip, DialogActions, DialogContent, Dialog, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { ValidateEmail } from "../Common/helpers";
import LoadingButton from "@mui/lab/LoadingButton";

export default function ShareDialog(props) {

    const [state, setState] = useState({ dests: [], add: false, uid: props.state.params.uid });
    const [loadingState, setLoadingState] = useState(false);
    const handleClose = () => {
        props.onClose();
    };
    const handleAddDest = () => {
        var m = state.dests.concat(state.dest);
        setState((state) => ({ ...state, dests: m, dest: "", add: false }))
    };
    const handleDelete = (elm) => {
        const arr = state.dests.filter(item => item !== elm)
        setState((state) => ({ ...state, dests: arr }))
    };
    const handleChange = (event) => {

        setState({
            ...state,
            [event.target.name]: event.target.value,
        });
    };
    useEffect(() => {
        console.log("dest", state.dest, ValidateEmail(state.dest))
        setState((state) => ({ ...state, add: ValidateEmail(state.dest) }))
    }, [state.dest])


    const sendIt = () => {
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(state)
        };

        fetch("/api/321480bee0dc4acb917abbdbc0420d2c/" + props.state.params.uid, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        handleClose();

                        break;
                    case "err":
                        break;
                    default:
                        break;
                }
            });
    };

    return (
        <Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
            <DialogTitle id="add-user-dialog">
                <Typography variant="h5" gutterBottom>
                    Montrer à des amis
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Stack spacing={1}>
                    <Typography variant="body1">Vous pensez que cette offre pourrait intéresser vos connaissances ?</Typography>
                    <Stack flexDirection={"row"} alignItems={"center"} justifyContent={"space-between"}>
                        <TextField name="dest" size="small" margin="dense" fullWidth style="margin-right: 10px;" onChange={handleChange} value={state.dest} />
                        <Button startIcon={<PersonAddAltIcon />} onClick={handleAddDest} disabled={!state.add} variant="contained" style="padding: 5px;" > </Button>
                    </Stack>
                    <div>
                        {state.dests.map((d) => { return (<Chip label={d} variant="outlined" onDelete={() => handleDelete(d)} />) })}
                    </div>
                    <TextField multiline rows={3} placeholder="Message d'accompagnement (optionnel, on peut s'en charger)" />

                </Stack>
            </DialogContent>
            <DialogActions>
                <Stack flexDirection={"row"} justifyContent="space-between" style="width: 100%" alignItems={"center"}>

                    <Button onClick={handleClose}>Annuler</Button>

                    <LoadingButton onClick={sendIt} loading={loadingState} variant="contained" disabled={state.dests.length === 0}>Envoyer</LoadingButton>

                </Stack>
            </DialogActions>
        </Dialog>
    );
}
